export enum WorkflowType {
    UNDEFINED = 'Undefined',
    SEGMENTATION_TRAINING = 'SegmentationTraining',
    SEGMENTATION = 'Segmentation',
    SEGMENTATION_CONTINUE_TRAINING = 'SegmentationContinueTraining',
    APPLICATION = 'Application',
    DATASETS = 'Datasets',
}
